// 单规格订单详情
export default {
    heard_title: "项目订单详情",
    heard_btn: "返回",

    order_title: "提交订单",
    opt_close: "关闭订单",
    opt_memo: "订单备注",

    // 单规格项目信息
    th_itemInfo: "项目信息",
    tl_space_proj: "场地/项目名称",
    tl_proj: "项目",
    tl_spec_player: "车型/选手",
    tl_kartName: "车型",
    tl_price: "价格",
    tl_scheduleTime: "日期",
    tl_TicketNum: "票号",
    tl_group: "分组",
    tl_player: "选手",
    tl_scheduleCode: "场次",
    tl_quantity: "数量",
    tl_amount: "小计",
    tl_status: "状态",
    tb_cancel: "核销",
    tb_refund: "退款",
    tl_total: "合计：",

    // 多规格项目信息
    tl_scheduleDate: "日期",
    tl_timeSection: "时间",

    // 备注弹出框
    dt_memoOrder: "备注订单",
    dt_closeOrder: "关闭订单",
    dp_memo: "请输入备注内容",

    // 退款弹出框
    dt_refund: "退款",
    fl_reason: "退款原因",
    fp_reason: "请选择退款原因",
    fl_refundNum: "退款数量",
    fl_refundOrderAmount: "订单金额",
    fl_refundAmount: "确认退款金额",
    fl_refundDesc: "退款说明",

    // 核销弹出框
    dt_cancel: "核销",
    dl_tip: "是否确认核销?",
    fl_cancelNum: "核销数量:",

    // 相关提示
    sm_refund: "退款成功",
    em_refund: "退款失败",
    sm_cancel: "核销成功",
    em_cancel: "核销失败",
    em_cancelMin: "核销数量最少为1",
    em_cancelMax: "核销数量已达到最大值",
    em_refundReason: "请选择退款原因",
    em_refundNum: "退款金额大于订单金额",
    em_refundMin: "退款数量最少为1",
    em_refundMax: "可退款数量已达到最大",
    sm_closeOrder: "关闭订单成功",
    sm_updateMemo: "备注订单成功",

    // 过滤器
    // projStatusFilter
    ft_notPaid: "待支付",
    ft_notConsumed: "待核销",
    ft_consumed: "已核销",
    ft_completed: "已完成",
    ft_expired: "已过期",
    ft_deleted: "已删除",
    ft_refunded: "已退款",
    ft_changedl: "已改签",

    // stepStatusFilter
    ft_create: "创建订单",
    ft_update: "更新订单",
    ft_payment: "支付订单",
    ft_confirm: "确认订单",
    ft_cancel: "取消订单",
    ft_close: "关闭订单",
    ft_complete: "完成订单",
    ft_apply_after_sale: "申请售后",
    ft_complete_after_sale: "完成售后",
    ft_delete: "删除订单",

    // payStatusFilter
    ft_not_paid: "未支付",
    ft_paid: "已支付",
    ft_paying: "支付中"
};
